import { NavLink, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';


const ActiveNavLinkButton = ({ to, children, ...props }) => {
  const location = useLocation();

  const isActive = location.pathname === to;

  return (
    <Button
      variant={isActive ? 'contained' : 'outlined'}
      component={NavLink}
      to={to}
      active={isActive.toString()} // Pass the active state to the styled component
      {...props}
    >
      {children}
    </Button>
  );
};

export default ActiveNavLinkButton;